import { Tooltip } from "antd";
import {
  TbSortAscendingNumbers,
  TbSortDescendingNumbers,
} from "react-icons/tb";
import { SortOrder } from "vl-api/vlSchemas";
import styles from "./style.module.scss";

interface SortOrderButtonProps {
  sortOrder: SortOrder;
  onClick: () => void;
}

const SORT_TOOLTIP: Record<SortOrder, string> = {
  asc: "Lowest confidence first. Click to show the highest first",
  desc: "Highest confidence first. Click to show the lowest first",
};

/** Toggles the confidence sort of the final review samples */
export default function SortOrderButton({
  sortOrder,
  onClick,
}: SortOrderButtonProps) {
  const Icon =
    sortOrder === "asc" ? TbSortAscendingNumbers : TbSortDescendingNumbers;
  return (
    <Tooltip title={SORT_TOOLTIP[sortOrder]} mouseEnterDelay={0.4}>
      <button
        type="button"
        className={styles.sortButton}
        onClick={onClick}
        aria-label={SORT_TOOLTIP[sortOrder]}
        data-testid="final-review-sort"
        data-sort-order={sortOrder}
      >
        <Icon size={20} />
      </button>
    </Tooltip>
  );
}
